
<div class="options-wrapper">
	<div class="options-wrapper-compact" :open="open">
		<div class="margin-tp-5">
			<Icon
				v-if="!open"
				name="i-hamburger"
				type="filled"
				size="medium"
				state="dark"
				class="margin-lt-6"
				@click="toggleOptions()"
			/>
		</div>
		<Icon
			v-if="open"
			name="i-hamburger-close"
			:effects="false"
			size="medium"
			state="dark"
			type="filled"
			class="margin-tp-6 margin-lt-6"
			@click="toggleOptions()"
		/>
	</div>
	<div class="options-wrapper-backout" :open="open" @click="toggleOptions()" />
	<div class="flow-options" :open="open">
		<slot />
		<div v-if="$slots['footer']" class="options-wrapper-footer">
			<slot name="footer" />
		</div>
	</div>
</div>
